// Integrations Tour
// Connecting payment, calendar, social, accounting and third-party tools
// Selector policy: step 1 pins to the LIVE-VERIFIED sidebar id (#sb_settings); the teaching steps are
// deliberate centered cards — no guessed element selectors (a wrong spotlight is worse than none).

export const integrationsTour = {
  id: 'integrations',
  name: 'Integrations Tour',
  displayName: 'Connect Your Whole Stack',
  description: 'Connecting payment, calendar, social, accounting and third-party tools',
  estimatedDuration: '4 minutes',
  category: 'feature',
  autoStart: false,
  prerequisiteTours: ['ftux'],

  config: {
    animate: true,
    overlayOpacity: 0.75,
    smoothScroll: true,
    allowClose: true,
    showProgress: true
  },

  steps: [
    {
      element: '#sb_settings',
      popover: {
        title: "🔌 Welcome to Integrations",
        description: `
          Your account is the hub — integrations are the spokes. Connect the tools you already use so data flows instead of being retyped.
        `,
        side: 'right',
        align: 'center'
      }
    },

    {
      popover: {
        title: "💳 Payments: Stripe & PayPal",
        description: `
          Connect **Stripe** or **PayPal** to take money anywhere in your account — invoices, funnels, payment links, subscriptions.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📅 Calendars: Google & Outlook",
        description: `
          Two-way **calendar sync** means your real availability drives bookings, and every new appointment lands on the calendar you already live in.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📧 Email & Phone",
        description: `
          Connect your **email sending** and **phone** services so messages come from your domain and number — better deliverability, better trust.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📱 Social Accounts",
        description: `
          Link **Facebook**, **Instagram**, **Google Business**, **LinkedIn**, and **TikTok** to publish from the Social Planner and pull messages into your inbox.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🧾 Accounting Sync",
        description: `
          Push invoices and payments into **QuickBooks**, **Xero**, or **Wave** so your books stay current without double entry.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🔗 Zapier & Webhooks",
        description: `
          Not on the list? **Zapier** and **webhooks** connect virtually anything, and workflows can call an external service directly.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🔑 API Keys & Private Integrations",
        description: `
          For custom builds, create a **private integration** token. Scoped access, revocable any time — the safe way to let your own tools in.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎉 Everything Talks",
        description: `
          You now know how to:

✅ Take payments and sync calendars
✅ Connect email, phone, and social
✅ Keep the books current
✅ Extend with Zapier, webhooks, and the API

**Next:** connect your gateway and calendar — those two unlock the most.
        `,
        side: 'over',
        align: 'center',
        showButtons: ['close'],
        doneBtnText: 'Done →'
      }
    }
  ]
};
